module.exports = __webpack_public_path__ + "img/cc.4513d183.svg";